import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@material-ui/core';
import React from 'react';
import moment from 'moment';
import SortableTableCell from '../../../../components/atom/SortableTableCell';
import TablePager from '../../../../components/atom/TablePager';
import { formatMoney } from '../../../../utils';

const DiscountPackageName = ({ discountData }) => {
    const discount = discountData?.booking_item_ticket?.bookingItemDiscount?.discount_package;
    const link = `/admin/client/${discount?.client_id}/discountpackages/${discount?.id}`;

    if (discount && discount.name) {
        return (
            <p style={{ margin: 0 }}>
                <a href={`${link}`} target="_blank" rel="noopener noreferrer">
                    {discount.name}
                </a>
            </p>
        );
    }

    if (discountData && discountData.name) {
        return <div>{discountData.name}</div>;
    }

    return <div>-</div>;
};

const BookingPaymentsTable = ({
    data,
    sort,
    sortDir,
    setSorting,
    page,
    setPage,
    pageSize,
    setPageSize,
    showDiscounts
}) => {
    return (
        <Grid container item>
            <TableContainer>
                <Table className="mt-2" style={{ backgroundColor: 'white' }} size="small">
                    <TableHead>
                        <TableRow>
                            <SortableTableCell
                                arrow={sort === 'firstname' ? sortDir : ''}
                                onClick={() => setSorting('firstname')}
                            >
                                Guest name
                            </SortableTableCell>
                            <SortableTableCell
                                arrow={sort === 'amount' ? sortDir : ''}
                                onClick={() => setSorting('amount')}
                            >
                                Amount
                            </SortableTableCell>
                            {!showDiscounts && (
                                <>
                                    <SortableTableCell
                                        arrow={sort === 'type' ? sortDir : ''}
                                        onClick={() => setSorting('type')}
                                    >
                                        Type
                                    </SortableTableCell>
                                    <SortableTableCell
                                        arrow={sort === 'last4' ? sortDir : ''}
                                        onClick={() => setSorting('last4')}
                                    >
                                        Last4
                                    </SortableTableCell>
                                    <SortableTableCell
                                        arrow={sort === 'note' ? sortDir : ''}
                                        onClick={() => setSorting('note')}
                                    >
                                        Note
                                    </SortableTableCell>
                                </>
                            )}
                            <SortableTableCell
                                arrow={sort === 'created_at' ? sortDir : ''}
                                onClick={() => setSorting('created_at')}
                            >
                                Booked on
                            </SortableTableCell>
                            <SortableTableCell
                                arrow={sort === 'company.name' ? sortDir : ''}
                                onClick={() => setSorting('company.name')}
                            >
                                Client
                            </SortableTableCell>
                            <SortableTableCell
                                arrow={sort === 'activity.name' ? sortDir : ''}
                                onClick={() => setSorting('activity.name')}
                            >
                                Activity name
                            </SortableTableCell>
                            {!showDiscounts && (
                                <>
                                    <SortableTableCell
                                        arrow={sort === 'activity_start' ? sortDir : ''}
                                        onClick={() => setSorting('activity_start')}
                                    >
                                        Activity start time
                                    </SortableTableCell>
                                    <SortableTableCell
                                        arrow={sort === 'status' ? sortDir : ''}
                                        onClick={() => setSorting('status')}
                                    >
                                        Status
                                    </SortableTableCell>
                                    <TableCell>Payment status</TableCell>
                                </>
                            )}
                            {showDiscounts && (
                                <>
                                    <TableCell>Agency discount name</TableCell>
                                    <TableCell>Agency discount amount</TableCell>
                                    <TableCell>Vendor discount name</TableCell>
                                    <TableCell>Vendor discount amount</TableCell>
                                </>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.bookingPayments &&
                            data?.bookingPayments.map(payment => {
                                return (
                                    <TableRow key={payment.id}>
                                        <TableCell>{payment.guest}</TableCell>
                                        <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
                                            {formatMoney(payment.amount)}
                                        </TableCell>
                                        {!showDiscounts && (
                                            <>
                                                <TableCell>{payment.type}</TableCell>
                                                <TableCell>{payment.last4}</TableCell>
                                                <TableCell>{payment.note}</TableCell>
                                            </>
                                        )}
                                        <TableCell>
                                            {moment
                                                .utc(payment.bookedAt)
                                                .format('MMMM Do YYYY, h:mm a')}
                                        </TableCell>
                                        <TableCell>{payment.company}</TableCell>
                                        <TableCell>
                                            {payment.activities.map(e => {
                                                return <div key={e.id}>{e.name}</div>;
                                            })}
                                        </TableCell>
                                        {!showDiscounts && (
                                            <>
                                                <TableCell>
                                                    {payment.activities.map(e => {
                                                        return (
                                                            <div key={e.id}>
                                                                {moment
                                                                    .utc(e.start)
                                                                    .format('MMMM Do YYYY, h:mm a')}
                                                            </div>
                                                        );
                                                    })}
                                                </TableCell>
                                                <TableCell>
                                                    {payment.activities.map(e => {
                                                        return <div key={e.id}>{e.status}</div>;
                                                    })}
                                                </TableCell>
                                                <TableCell>{payment.refundStatus}</TableCell>
                                            </>
                                        )}
                                        {showDiscounts && (
                                            <>
                                                <TableCell>
                                                    {payment.agencyDiscount.length > 0
                                                        ? payment.agencyDiscount.map(e => (
                                                              <DiscountPackageName
                                                                  discountData={e}
                                                              />
                                                          ))
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {payment.agencyDiscount.length > 0
                                                        ? payment.agencyDiscount.map(e => {
                                                              return (
                                                                  <div key={e.name}>
                                                                      {formatMoney(
                                                                          Math.abs(e.net + e.tax)
                                                                      )}
                                                                  </div>
                                                              );
                                                          })
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {payment.vendorDiscount.length > 0
                                                        ? payment.vendorDiscount.map(e => (
                                                              <DiscountPackageName
                                                                  discountData={e}
                                                              />
                                                          ))
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {payment.vendorDiscount.length > 0
                                                        ? payment.vendorDiscount.map(e => {
                                                              return (
                                                                  <div key={e.name}>
                                                                      {formatMoney(
                                                                          Math.abs(e.net + e.tax)
                                                                      )}
                                                                  </div>
                                                              );
                                                          })
                                                        : '-'}
                                                </TableCell>
                                            </>
                                        )}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Grid container justifyContent="flex-end">
                <TablePager
                    total={data?.total}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                />
            </Grid>
        </Grid>
    );
};

export default BookingPaymentsTable;
